module.exports = __webpack_public_path__ + "static/media/pdf.6ae3a267.svg";